import React, { useEffect } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

interface CustomMessage {
  id: number;
  title: string;
  message: string;
}

export function CustomMessagesPanel() {
  const [selectedMessageId, setSelectedMessageId] = React.useState<string>("");
  const [messages, setMessages] = React.useState<CustomMessage[]>([]);

  useEffect(() => {
    loadMessages();
  }, []);

  const loadMessages = () => {
    const savedMessages = localStorage.getItem("quickMessages");
    if (savedMessages) {
      try {
        const parsedMessages = JSON.parse(savedMessages);
        setMessages(parsedMessages);
        if (parsedMessages.length > 0) {
          setSelectedMessageId(parsedMessages[0].id.toString());
        }
      } catch (error) {
        console.error("Error parsing quick messages:", error);
      }
    }
  };

  const selectedMessage = messages.find(
    (msg) => msg.id.toString() === selectedMessageId
  );

  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle>Mensagem de Apresentação</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="presentation-message">
            Selecione a mensagem de apresentação
          </Label>
          <Select
            value={selectedMessageId}
            onValueChange={setSelectedMessageId}
          >
            <SelectTrigger className="w-full">
              <SelectValue placeholder="Selecione uma mensagem" />
            </SelectTrigger>
            <SelectContent>
              {messages.map((message) => (
                <SelectItem key={message.id} value={message.id.toString()}>
                  {message.title}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="message-preview">Prévia da mensagem</Label>
          <Textarea
            id="message-preview"
            value={selectedMessage?.message || ""}
            readOnly
            className="min-h-[100px] bg-muted"
          />
        </div>
      </CardContent>
    </Card>
  );
}